module.exports = __webpack_public_path__ + "media/2tentative.eb580668.mp3";